'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ibantools = require('ibantools');

var _mobxReact = require('mobx-react');

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _rules = require('../Webform/rules');

var _rules2 = _interopRequireDefault(_rules);

var _RuleHint = require('../RuleHint');

var _RuleHint2 = _interopRequireDefault(_RuleHint);

var _WebformUtils = require('../WebformUtils');

var _WebformUtils2 = _interopRequireDefault(_WebformUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IBAN = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IBAN, _Component);
  (0, _createClass3.default)(IBAN, null, [{
    key: 'rewriteValue',
    value: function rewriteValue(value) {
      return (value || '').replace(/\s/g, '').toUpperCase();
    }
  }]);

  function IBAN(props) {
    (0, _classCallCheck3.default)(this, IBAN);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IBAN.__proto__ || (0, _getPrototypeOf2.default)(IBAN)).call(this, props));

    _rules2.default.delete('pattern_' + props.field['#webform_key']); // IBAN has own validation, pattern is only used in back end.

    _rules2.default.set('iban_' + props.field['#webform_key'], {
      rule: function rule(value) {
        return (0, _ibantools.isValidIBAN)(value);
      },
      hint: function hint() {
        return _react2.default.createElement(_RuleHint2.default, { key: 'iban_' + props.field['#webform_key'], hint: _WebformUtils2.default.getCustomValue(props.field, 'ibanError', props.settings) || _WebformUtils2.default.getErrorMessage(props.field, '#required_error') || 'Please enter a valid IBAN.' });
      },
      shouldValidate: function shouldValidate(field) {
        return field.isBlurred;
      }
    });
    return _this;
  }

  (0, _createClass3.default)(IBAN, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Input2.default, (0, _extends3.default)({}, this.props, {
        autoComplete: 'iban'
      }));
    }
  }]);
  return IBAN;
}(_react.Component), _class2.meta = {
  validations: [function (el) {
    return 'iban_' + el.key;
  }]
}, _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#webform_key': _propTypes2.default.string.isRequired,
    '#ibanError': _propTypes2.default.string
  }).isRequired,
  settings: _propTypes2.default.shape().isRequired
}, _temp)) || _class;

exports.default = IBAN;